
import Component, { mixins } from 'vue-class-component'
import NewsMixin from './news-mixin/index'
import NewsItem from '@/components/news-item/index.vue'
import ItemTitle from '@/components/item-title/index.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { InformationNewsManageImpl } from '../manages/InformationNewsManageImpl'
import { InformationNewsService } from '../services/HomeService'
@Component({
  components: {
    ItemTitle,
    NewsItem
  }
})

export default class Index extends mixins(NewsMixin) {
  private manage = new InformationNewsManageImpl(new InformationNewsService())
  @Prop() private list!: Array<any>
  @Prop() private pid!: string

  showDetail (info: any) {
    // localStorage.setItem('selectedChapter', JSON.stringify([this.pid, info.projectSystemId]))
    // this.$router.push(`registration/${item.pid}/${item.categoryId}`)
    const url = process.env.VUE_APP_SMALL_URL
    window.location.href = (url + `/channel.html#/registration/${info.pid}/${info.categoryId}`)
  }

  get asyncList () {
    if (this.isShowMore) {
      return this.list
    } else {
      if (this.list) {
        return this.list.filter((item: any, index: number) => index <= 9)
      } else {
        return this.list
      }
    }
  }

  get showMoreBUtton () {
    if (this.list) {
      return this.list.length > 10
    } else {
      return false
    }
  }

  private isShowMore = false

  seeMore () {
    this.isShowMore = !this.isShowMore
  }
}
